import clsx from 'clsx';
import { forwardRef } from 'react';

export const TableHeader = forwardRef<HTMLTableSectionElement, React.HTMLAttributes<HTMLTableSectionElement>>(
    ({ className, ...props }, ref) => (
        // Added top-[0.25px] for subpixel rounding issues in Chrome on Windows
        <thead ref={ref} className={clsx('sticky top-0 z-10 m-0 isolate', className)} {...props} />
    )
);
